export default __webpack_public_path__ + "static/media/if-goiano.309f77ee.png";